import { EditNode, DeleteMenuItem } from "src/enterprise/ra-tree";
import React, { useContext, useEffect } from "react";
import {
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  useRecordContext,
  required,
} from "react-admin";
import Transformer from "src/common/Transformer";
import { CategoryContext } from "./CategoryList";
import { Grid } from "@mui/material";
import { FileInput } from "../../../components/file-input/FileInput";
import { useEditNodeController } from "src/enterprise/ra-tree/controllers/useEditNodeController";
import { EditorBuilderInput, ColorInput } from "src/components/input";

export function CategoryEdit() {
  const controller = useEditNodeController();

  const transform = async (data) => {
    let parent = data.parent?.id;
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt", "parent", "children"],
    });

    if (parent) {
      data.parent = parent;
    }

    return data;
  };

  function CategoryEditToolbar(props: ToolbarProps) {
    return (
      <Toolbar {...props} sx={{justifyContent: "space-between"}}>
        <SaveButton alwaysEnable/>
        <DeleteMenuItem confirmTitle={`Delete Category`} mutationMode="pessimistic" className="removeButton"/>
      </Toolbar>
    );
  }

  return (
    <EditNode
      key={`category-${controller?.record?.id}`}
      transform={transform}
      mutationMode="pessimistic"
      resource={`admin/product/categories`}
    >
      <SimpleForm toolbar={<CategoryEditToolbar />}>
        <Grid container sm={12} lg={6} rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12}>
            <TextInput source="legacy_id"/>
          </Grid>          
          <Grid item sm={12}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12}>
            <TextInput source="slug" validate={required()} />
          </Grid>
          <Grid item sm={12}>
            <EditorBuilderInput source="description" base64 fullWidth/>
          </Grid>
          <Grid item sm={12}>
            <ColorInput source="marker" label="Color Marker"/>
          </Grid>
          <Grid item sm={12}>
            <FileInput
              source="image"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
              multiple={false}
            />
          </Grid>
          <Grid item sm={12}>
            <FileInput
              source="banner"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
              multiple={false}
            />
          </Grid>
          <Grid item sm={12}>
            <FileInput
              source="mobile_banner"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
              multiple={false}
            />
          </Grid>
          <Grid item sm={12}>
              <TextInput source="meta_title"/>
          </Grid>
          <Grid item sm={12}>
            <TextInput
              source="meta_description"
              rows={4}
              fullWidth
              multiline
            />
          </Grid>
          <Grid item sm={12}>
            <TextInput source="meta_keywords" multiline rows={4}/>
          </Grid>
        </Grid>

        <CategoryEditDataInitializer/>
      </SimpleForm>
    </EditNode>
  );
}

const CategoryEditDataInitializer = () => {
  const record = useRecordContext();
  const { setCurrentParent } = useContext(CategoryContext);

  useEffect(() => {
    setCurrentParent(record);
  }, [record]);

  return null;
};
